import { TaskDependency } from "../../types/ganttChart";
import drawerStyles from "../../styles/drawer.module.css";
import timestampService from "../../service/timestampService";
import labels from "../../utils/labels";
import { ReactComponent as WarningIcon } from "../../assets/icons/warning.svg";
import { DependencyMessageFactory } from "../../utils/dependencyUtil";
import DependencyChip from "../UI/chips/DependencyChip";

const TaskDependencyBox = ({
  dependency,
  violation,
}: {
  dependency?: TaskDependency;
  violation: boolean;
}) => {
  return (
    <section
      className={`${drawerStyles.taskDependency} ${violation && drawerStyles.hasViolations}`}
    >
      <div className="pt-[3px]">
        {violation ? (
          <WarningIcon width={14} height={14} />
        ) : (
          <DependencyChip color="var(--col-success-primary)" />
        )}
      </div>

      <div className="flex flex-col gap-[var(--spacing-md)]">
        {violation && (
          <p className={drawerStyles.dependencyTitle}>{labels.violation} </p>
        )}
        <div className={drawerStyles.dependencyInfoRow}>
          {violation && <p>{labels.employee}</p>}
          <h5 className={drawerStyles.dependencyTitle}>
            {dependency?.employeeName ? dependency?.employeeName : "Uplanlagt"}
          </h5>
        </div>
        <div className={drawerStyles.dependencyInfoRow}>
          <p>{labels.visitHours}</p>
          <div className={drawerStyles.dependencyWorkTime}>
            <p>
              {dependency?.start &&
                timestampService.getHoursAndMinutesTimestamp(
                  dependency?.start,
                )}{" "}
              -{" "}
              {dependency?.end &&
                timestampService.getHoursAndMinutesTimestamp(dependency?.end)}
            </p>
          </div>
        </div>
        <ul className={drawerStyles.dependencyMessageRow}>
          {DependencyMessageFactory.getDependencyMessages(dependency!).map(
            (message) => (
              <li>{message}</li>
            ),
          )}
        </ul>
      </div>
    </section>
  );
};

export default TaskDependencyBox;
